import { useQuery } from '@tanstack/react-query';
import { getOrganizationAccess } from '@upright/ui/api/iam/organizations';

/**
 * Hook to check if the current user has the CREATE_COMPANIES permission
 * for a specific organization.
 *
 * This uses the existing /api/organizations/{id}/access endpoint which returns
 * the user's role and permissions (backend handles TEAM user bypass automatically).
 */
export function useOrganizationHasCreateCompaniesPermission(organizationId: number | undefined) {
  const accessQuery = useQuery({
    queryKey: ['get-organization-access', organizationId],
    queryFn: async () => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }
      return await getOrganizationAccess(organizationId);
    },
    enabled: organizationId !== undefined,
  });

  return {
    hasPermission: accessQuery.data?.canCreateCompanies ?? false,
    isLoading: accessQuery.isLoading,
    isError: accessQuery.isError,
    error: accessQuery.error,
  };
}
